import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import Webcam from "react-webcam";
import { toast } from "react-toastify";

import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
    InputGroup,
    Table,
    Modal,
    ModalHeader,
    ModalBody,

} from "reactstrap";
import { addJob, getClinic, getJob, getPatient, getPatients, getPatientsByClinicId, getPCAREByVisitId, getVisitsByPatientId } from "../../service/api";
import { jwtDecode } from "jwt-decode";
import Addpatient from "pages/Addpatient/Addpatient";


const defaultValue = {
    date: "",
    Optum: "",
    practisc_number: "",
    practisc_address: "",
    practisc_mobilenum: "",
    practisc_name: "",
    patient_name: "",
    patientID: "",
    contactno: "",
    vc_reference: "",
    frame: "",
    frame_type: "",
    lens_type: "",
    surfacing_lab: "",
    reference: "",
    faculty: "",
    notes: "",
    visit: "",
}



const Jobform = () => {
    const [imageSrc, setImageSrc] = useState('');
    const [webcamOpen, setWebcamOpen] = useState(false);
    const [alluserlist, setallusers] = useState({ users: [] })
    const [alljobdata, setalljob] = useState({ users: [] })
    const [selectedPatientId, setSelectedPatientId] = useState('');
    const [visits, setVisits] = useState([]);
    const [patients, setPatients] = useState([]);
    const [selectedGroup, setselectedGroup] = useState(null);
    const [loading, setLoading] = useState(true);
    const [pcareData, setPcareData] = useState(null);
    const [selectedPatientName, setSelectedPatientName] = useState('');
    const [allcliniclist, setallclinic] = useState([]);
    const [showFrameType, setShowFrameType] = useState(false);
    const [addPatientModal, setAddPatientModal] = useState(false);
    const todayDate = new Date().toISOString().split('T')[0];
    const [clinicIdFromToken, setClinicIdFromToken] = useState(null);
    const [selectedClinic, setSelectedClinic] = useState("");

    const [jobData, setJobData] = useState({
        ...defaultValue,
        date: todayDate
    })
    const [isLabToSupply, setIsLabToSupply] = useState(false);
    const [formErrors, setFormErrors] = useState({ patient: false });

    const navigate = useNavigate();

    const onValueChange = async (e) => {
        const { name, value } = e.target;
        setJobData({ ...jobData, [e.target.name]: e.target.value });
        console.log(jobData);

        if (e.target.name === "Optum" && e.target.value === "Optum") {
            setIsLabToSupply(true);
        } else if (e.target.name === "Optum" && e.target.value !== "Self refral") {
            setIsLabToSupply(false);
        }

        if (e.target.name === "patient_name") {
            const selectedName = e.target.value;
            setSelectedPatientName(selectedName);
            const selectedUser = alluserlist.users.find(user => `${user.firstname} ${user.lastname}` === selectedName);
            setSelectedPatientId(selectedUser ? selectedUser._id : '');
            setJobData({ ...jobData, patientID: selectedUser ? selectedUser._id : '', patient_name: selectedName });
        }



        if (name === "visit") {
            try {
                const response = await getPCAREByVisitId(value);

                if (response?.data) {
                    // If the response is a message saying no records
                    if (response.data.message === "No patient care records found for this visit_id") {
                        toast.info("No patient care records found for this visit.", {
                            position: "top-right",
                            autoClose: 3000,
                        });
                        setPcareData(null);
                    } else {
                        // Data exists and is not the "no records" message
                        console.log("✅ PCARE Data:", response.data);
                        setPcareData(Array.isArray(response.data) ? response.data[0] : response.data);
                    }
                    if (response?.data && response.data !== null && !response.data.message) {
                        const pcare = Array.isArray(response.data) ? response.data[0] : response.data;

                        // Update jobData based on pcare values
                        const mobileNumber =
                            pcare?.visit_id?.patientid?.mobile ||
                            pcare?.patientid?.mobile ||
                            "";
                        setJobData(prev => ({
                            ...prev,
                            contactno: mobileNumber,
                            frame_type: pcare.frame_type || "",
                            lens_type: pcare.lens_type || "",
                            frame: pcare.frame_type ? "Yes" : "No"
                        }));

                        // Show frame type if frame_type exists
                        setShowFrameType(!!pcare?.frame_type);
                    }

                } else {
                    toast.info("No patient care records found for this Visit.", {
                        position: "top-right",
                        autoClose: 3000,
                    });
                    setPcareData(null);
                }
            } catch (err) {
                console.error("Error fetching PCARE data", err);
                toast.error("Failed to fetch patient care data.", {
                    position: "top-right",
                    autoClose: 3000,
                });
                setPcareData(null);
            }
        }


    }
    const onValueframChange = (e) => {
        const { name, value } = e.target;

        // ✅ Update jobData properly
        setJobData(prev => ({
            ...prev,
            [name]: value
        }));

        if (name === "frame") {
            setShowFrameType(value === "Yes");
        }
    };

    // const onValueframChange = (e) => {
    //     const { name, value } = e.target;
    //     if (name === "frame") {
    //         setShowFrameType(value === "Yes");
    //     }
    // }

    // useEffect(() => {
    //     const token = localStorage.getItem("token");
    //     if (token) {
    //         const decoded = jwtDecode(token);
    //         setClinicIdFromToken(decoded?.clinicID || null);
    //     }
    // }, []);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const decoded = jwtDecode(token);
            const clinicID = decoded?.clinicID || null;
            setClinicIdFromToken(clinicID);
            if (clinicID) {
                // fetch that clinic and auto fill
                getClinic().then(res => {
                    const clinic = res.data.find(c => c._id === clinicID);
                    if (clinic) {
                        setSelectedClinic(clinicID);
                        setPracticeDetails(clinic);
                    }
                });
            }
        }
    }, []);

    useEffect(() => {
        if (!clinicIdFromToken) {
            getallclinic();
        }
    }, [clinicIdFromToken]);
    const loadPatientsByClinic = async (clinicId) => {
        try {
            setLoading(true);
            const response = await getPatientsByClinicId(clinicId);

            if (Array.isArray(response?.data?.data)) {
                setPatients(response.data.data);
            } else {
                setPatients([]);
            }
        } catch (err) {
            console.error("Error loading patients:", err);
            setPatients([]);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (clinicIdFromToken) {
            loadPatientsByClinic(clinicIdFromToken);
        }
    }, [clinicIdFromToken]);
    // const handleClinicChange = (e) => {
    //     const clinicId = e.target.value;
    //     setSelectedClinic(clinicId);

    //     // reset dependent fields
    //     setPatients([]);
    //     setVisits([]);
    //     setselectedGroup(null);

    //     if (clinicId) {
    //         loadPatientsByClinic(clinicId);
    //     }
    // };

    const handleClinicChange = (e) => {
        const clinicId = e.target.value;
        setSelectedClinic(clinicId);

        setPatients([]);
        setVisits([]);
        setselectedGroup(null);

        if (clinicId) {
            loadPatientsByClinic(clinicId);

            // find selected clinic & fill details
            const clinic = allcliniclist.find(c => c._id === clinicId);
            if (clinic) {
                setPracticeDetails(clinic);
            }
        }
    };
    const getallclinic = async () => {
        try {
            let response;
            response = await getClinic();
            setallclinic(response.data);
        } catch (err) {
            console.error("Error fetching clinic(s)", err);
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = {
            patient: !selectedGroup,
        };
        setFormErrors(errors);
        if (errors.patient) return;
        await addJob(jobData);
        console.log(jobData);
        navigate("/job");
        toast.success("User saved successfully.", {
            position: "top-center",
            autoClose: 1500,
        })
    }
    const videoConstraints = {
        width: 400,
        height: 290,
        facingMode: "user"
    };

    const webcamRef = useRef(null);

    const capture = () => {
        const imageSrc = webcamRef.current.getScreenshot();
        setImageSrc(imageSrc);
    };


    useEffect(() => {
        getPatientAll();
        getjobform();
    }, [])


    // const getPatientAll = async () => {
    //     try {
    //         let response = await getPatient()
    //         if (response.error) {
    //             console.log("Error while fetching data:", response.error)
    //         } else {
    //             setallusers({ users: response.data || [] })
    //         }
    //     } catch (error) {
    //         console.log("Error while fetching data:", error)
    //     }
    // }

    const getPatientAll = async () => {
        try {
            const token = localStorage.getItem("token");
            let response;
            if (token) {
                const decoded = jwtDecode(token);
                const clinicID = decoded?.clinicID;

                response = clinicID
                    ? await getPatientsByClinicId(clinicID)
                    : await getPatients();

                if (response?.data?.data) {
                    setPatients(response.data.data);
                } else {
                    setPatients([]);
                }
            }
        } catch (error) {
            console.log("Error while fetching patient data:", error);
            setPatients([]);
        } finally {
            setLoading(false);
        }
    };
    const fetchVisitsByPatientId = async (patientId) => {
        try {
            const res = await getVisitsByPatientId(patientId);
            if (Array.isArray(res.data)) {
                console.log("✅ Fetched Visits:", res.data);
                setVisits(res.data); // directly use res.data
            } else {
                console.warn("⚠️ Visit data is not an array:", res.data);
                setVisits([]);
            }
        } catch (err) {
            console.error("❌ Error fetching visits", err);
            setVisits([]);
        }
    };
    // function handleSelectGroup(selectedOption) {
    //     setselectedGroup(selectedOption);

    //     const selectedPatient = patients.find(p => p._id === selectedOption.value);
    //     console.log("Selected patient:", selectedPatient);

    //     // Get visits for the selected patient
    //     fetchVisitsByPatientId(selectedOption.value);
    // }
    function handleSelectGroup(selectedOption) {

        setselectedGroup(selectedOption);

        const selectedPatient = patients.find(
            p => p._id === selectedOption.value
        );

        // ✅ SET PATIENT DATA INTO FORM STATE
        setJobData(prev => ({
            ...prev,
            patientID: selectedOption.value,
            patient_name: selectedPatient
                ? `${selectedPatient.firstname} ${selectedPatient.lastname}`
                : ""
        }));

        setSelectedPatientId(selectedOption.value);
        setFormErrors(prev => ({ ...prev, patient: false }));

        // load visits
        fetchVisitsByPatientId(selectedOption.value);
    }

    const getjobform = async () => {
        try {
            let response = await getJob();
            if (response.error) {
                console.log("Error while fetching data:", response.error);
            } else {
                const jobs = response.data || [];
                setalljob({ users: jobs });

                const currentDate = new Date();
                const dateStr = currentDate.toISOString().slice(0, 10).replace(/-/g, '');

                const jobCountToday = jobs.filter(job => job.reference && job.reference.startsWith(dateStr)).length;
                const referenceNo = `${dateStr}-${String(jobCountToday + 1).padStart(4, '0')}`;

                const now = new Date();
                const vcDateStr = now.getFullYear().toString() +
                    String(now.getMonth() + 1).padStart(2, '0') +
                    String(now.getDate()).padStart(2, '0');
                const vcPrefix = `JOB${vcDateStr}-`;
                const vcRefCount = jobs.filter(job => job.vc_reference && job.vc_reference.startsWith(vcPrefix)).length;
                const vcReferenceNo = `${vcPrefix}${String(vcRefCount + 1).padStart(3, '0')}`;

                setJobData(prevData => ({
                    ...prevData,
                    reference: referenceNo,
                    vc_reference: vcReferenceNo,
                }));

                console.log("Generated Reference No:", referenceNo);
                console.log("Generated VC Reference No:", vcReferenceNo);
            }
        } catch (error) {
            console.log("Error while fetching data:", error);
        }
    };

    const setPracticeDetails = (clinic) => {
        if (!clinic) return;

        setJobData(prev => ({
            ...prev,
            practisc_number: clinic.code || "",
            practisc_name: clinic.name || "",
            practisc_address: clinic.address || "",
            practisc_mobilenum: clinic.contactno || ""
        }));
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <div className="d-flex justify-content-between align-items-center mb-2">
                        {/* <CardTitle className="mb-4">ADD Patient</CardTitle> */}
                        <h4 className="page-title">Registration Job form</h4>
                        <Link to="/job" className="btn btn-danger">List</Link>
                    </div>
                    <Row>
                        <Card>
                            <CardBody>
                                <Form>
                                    {/* <Row>
                                        <Col md={12}>
                                            <h5 className="font-size-14 mb-3">
                                                Optom or Self refral?
                                            </h5>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <div
                                                    className="form-check form-radio-danger"
                                                    style={{ marginRight: "10px" }}
                                                >
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="Optum"
                                                        value="Optum"
                                                        // checked={jobData.Optum === "Optum"}

                                                        onChange={e => onValueChange(e)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="exampleRadios1"
                                                    >
                                                        Optom
                                                    </label>
                                                </div>
                                                <div
                                                    className="form-check form-radio-danger"
                                                    style={{ marginRight: "10px" }}
                                                >
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="Optum"
                                                        value="Self Referral"
                                                        // checked={jobData.Optum === "Self refral"}
                                                        onChange={e => onValueChange(e)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="exampleRadios2"
                                                    >
                                                        Self refral
                                                    </label>
                                                </div>
                                            </div>
                                            <br />
                                        </Col>
                                    </Row> */}
                                    <Row>
                                        {!clinicIdFromToken && (
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label>Practice</Label>
                                                    <select
                                                        className="form-control"
                                                        value={selectedClinic}
                                                        onChange={handleClinicChange}
                                                    >
                                                        <option value="">Select Practice</option>
                                                        {allcliniclist.map((clinic) => (
                                                            <option key={clinic._id} value={clinic._id}>
                                                                {clinic.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </Col>
                                        )}
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Date</Label>
                                                <Input type="date" className="form-control" value={jobData.date} name="date" onChange={(e) => onValueChange(e)} />
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* {isLabToSupply && ( */}
                                    {/* <> */}
                                    <Row>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Practice Number</Label>
                                                <Input type="text" className="form-control" name="practisc_number"
                                                    value={jobData.practisc_number} placeholder="Practice Name" onChange={(e) => onValueChange(e)} />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Practice Name</Label>
                                                <Input type="text" className="form-control" name="practisc_name"
                                                    value={jobData.practisc_name} placeholder="Practice Name" onChange={(e) => onValueChange(e)} />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Practice Address</Label>
                                                <Input type="text" className="form-control" name="practisc_address"
                                                    value={jobData.practisc_address} placeholder="Practice Name" onChange={(e) => onValueChange(e)} />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Practice phone no.</Label>
                                                <Input type="text" className="form-control" name="practisc_nobilenum"
                                                    value={jobData.practisc_mobilenum} placeholder="Practice phone no." onChange={(e) => onValueChange(e)} maxLength={13} onKeyPress={(e) => {
                                                        if (!/[0-9]/.test(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    inputMode="numeric" />
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* </> */}
                                    {/* )} */}
                                    <Row>
                                        {/* <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Patient Name</Label>
                                                <select name="patient_name" className="form-control" onChange={onValueChange}>
                                                    <option defaultValue>Select Patient</option>
                                                    {alluserlist.users.map((user, index) => (
                                                        <option key={index} value={`${user.firstname} ${user.lastname}`}>
                                                            {user.firstname + " " + user.lastname}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col> */}


                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-referenceNo" style={{ fontWeight: "bold" }}>
                                                    Select Patient  <button
                                                        type="button"
                                                        className="btn btn-sm btn-success ms-2"
                                                        onClick={() => setAddPatientModal(true)}
                                                        title="Add new patient"
                                                    >
                                                        +
                                                    </button>
                                                </Label>
                                                <Select
                                                    value={selectedGroup}
                                                    onChange={handleSelectGroup}
                                                    options={patients.map((patient) => ({
                                                        value: patient._id,
                                                        label: `${patient.firstname} ${patient.lastname} (${patient.mpino})`,
                                                    }))}
                                                    isDisabled={!clinicIdFromToken && !selectedClinic}
                                                    className="select2-selection"
                                                />
                                                {formErrors.patient && <span className="text-danger" style={{ fontSize: "13px" }}>* Please select a patient</span>}

                                                {/* <Select
                                                    value={selectedGroup}
                                                    onChange={handleSelectGroup}
                                                    options={patients.map((patient) => ({
                                                        value: patient._id,
                                                        label: `${patient.firstname} ${patient.lastname} (${patient.mpino})`
                                                    }))}
                                                    className="select2-selection"
                                                /> */}

                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-referenceNo" style={{ fontWeight: "bold" }}>
                                                    Select Visit
                                                </Label>
                                                <select name="visit" className="form-control" onChange={(e) => onValueChange(e)}>
                                                    <option value="">Choose...</option>

                                                    {visits.map((visit) => (
                                                        <option key={visit._id} value={visit._id}>
                                                            {visit.visit_no || "Visit No Missing"}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Input type="text" name="patientID" className="form-control" hidden value={selectedPatientId} />
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">patient contact No.</Label>
                                                <Input type="text" className="form-control" name="contactno" value={jobData.contactno}
                                                    placeholder="E.g - 27843938590" onChange={(e) => onValueChange(e)} maxLength={10} onKeyPress={(e) => {
                                                        if (!/[0-9]/.test(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    inputMode="numeric" />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">JOB Reference No.</Label>
                                                <Input type="text" className="form-control" name="vc_reference" value={jobData.vc_reference || ''} readOnly onChange={(e) => onValueChange(e)} />
                                            </div>
                                        </Col>
                                        {/* <Col lg={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-login">Frame supplied</Label>

                                                <select
                                                    name="frame"
                                                    className="form-control"
                                                    value={jobData.frame} // Bind to jobData
                                                    onChange={(e) => onValueframChange(e)}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </select>

                                            </div>
                                        </Col> */}
                                        {/* {showFrameType && (
                                            <Col lg={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-login">Frame type</Label>
                                                 
                                                    <select
                                                        name="frame_type"
                                                        className="form-control"
                                                        value={jobData.frame_type} // Bind to jobData
                                                        onChange={(e) => onValueChange(e)}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Full Rim">Full Rim</option>
                                                        <option value="Semi-rimless">Semi-rimless</option>
                                                        <option value="Nylon-Sahpe">Nylon-Sahpe</option>
                                                    </select>
                                                </div>
                                            </Col>
                                        )} */}
                                        {/* <Col lg={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-login">Lens type</Label>
                                               
                                                <select
                                                    name="lens_type"
                                                    className="form-control"
                                                    value={jobData.lens_type} // Bind to jobData
                                                    onChange={(e) => onValueChange(e)}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Single Vision">Single Vision</option>
                                                    <option value="Bifocal Lens">Bifocal Lens</option>
                                                    <option value="Multifocal">Multifocal</option>
                                                </select>
                                            </div>
                                        </Col> */}
                                        {/* <Col lg={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-login">Surfacing Lab</Label>
                                                <select name="surfacing_lab" className="form-control" onChange={(e) => onValueChange(e)}>
                                                    <option defaultValue>Select</option>
                                                    <option>Yes</option>
                                                    <option>No</option>
                                                </select>
                                            </div>
                                        </Col> */}
                                        {/* <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Reference No.</Label>
                                                <Input type="text" className="form-control" name="reference" value={jobData.reference || ''} readOnly onChange={(e) => onValueChange(e)} />
                                            </div>
                                        </Col> */}
                                        {/* <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Faculty Manager</Label>
                                                <Input type="text" className="form-control" name="faculty" placeholder="Faculty Manager" onChange={(e) => onValueChange(e)} />
                                            </div>
                                        </Col> */}
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Notes</Label>
                                                <Input type="textarea" className="form-control" name="notes" placeholder="Comments" onChange={(e) => onValueChange(e)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <Label htmlFor="live-image-capture">Live Image Capture</Label>
                                                <Row>
                                                    <Col md={5}>
                                                        {webcamOpen ? (
                                                            <div>
                                                                <Webcam
                                                                    audio={false}
                                                                    ref={webcamRef}
                                                                    screenshotFormat="image/jpeg"
                                                                    videoConstraints={videoConstraints}
                                                                />
                                                                <Button onClick={() => capture(webcamRef)} color="primary" className="mt-2">
                                                                    Capture
                                                                </Button>
                                                                <Button onClick={() => setWebcamOpen(false)} color="secondary" className="mt-2 ml-2">
                                                                    Close
                                                                </Button>
                                                            </div>
                                                        ) : (
                                                            <Button onClick={() => setWebcamOpen(true)} color="primary">
                                                                Open Webcam
                                                            </Button>
                                                        )}
                                                    </Col>
                                                    <Col md={6}>
                                                        {imageSrc && (
                                                            <div className="mt-3">
                                                                <img src={imageSrc} alt="Captured" className="img-fluid" />
                                                            </div>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                    <div>
                                        <button className="btn btn-primary w-md mx-2" onClick={(e) => handleSubmit(e)}>
                                            Save
                                        </button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Row>

                    <Modal isOpen={addPatientModal} toggle={() => setAddPatientModal(!addPatientModal)} size="xl">
                        <ModalBody>
                            <Addpatient
                                onPatientAdded={() => {
                                    setAddPatientModal(false); // close modal
                                    getPatientAll();           // refresh the patient list
                                }}
                                skipNavigation={true}
                                isModal={true}
                            />
                        </ModalBody>
                    </Modal>

                </Container>
            </div>
        </React.Fragment >
    )
}

export default Jobform
